var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: {
      label: _vm.name,
      "min-width": _vm.columnWidth,
      fixed: false,
      align: "center",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-number", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkEdit(
                    scope.$index,
                    _vm.code,
                    scope.row[_vm.code],
                    scope.row
                  ),
                  expression:
                    "checkEdit(scope.$index, code, scope.row[code], scope.row)",
                },
              ],
              ref: "input_" + scope.$index + "_" + "code",
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                precision: _vm.precision,
                min: _vm.min,
                max: _vm.max,
                step: _vm.step,
                require: _vm.getRequire,
                rules: _vm.rules,
              },
              on: { onFieldChange: _vm.onFieldChange },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
            _c("ik-table-number-tag", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.checkEdit(
                    scope.$index,
                    _vm.code,
                    scope.row[_vm.code],
                    scope.row
                  ),
                  expression:
                    "!checkEdit(scope.$index, code, scope.row[code], scope.row)",
                },
              ],
              attrs: {
                value: scope.row[_vm.code],
                precision: _vm.precision,
                "error-sign": _vm.errorSign[scope.$index],
                message: _vm.message[scope.$index],
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }